import { AuthenticationValidateConfirmationApiData } from "../../end-points-dto/api-dto/authentication/authentication-validate-confirmation-api-data";
import { AuthenticationProcessConfirmationApiData } from "../../end-points-dto/api-dto/authentication/authentication-process-confirmation-api-data";
var AuthenticationConverter = /** @class */ (function () {
    function AuthenticationConverter() {
    }
    AuthenticationConverter.convertToAuthenticationValidateConfirmationApiData = function (authenticationValidateConfirmationVoData) {
        var authenticationValidateConfirmationApiData = new AuthenticationValidateConfirmationApiData();
        authenticationValidateConfirmationApiData.firstName = authenticationValidateConfirmationVoData.firstName;
        authenticationValidateConfirmationApiData.lastName = authenticationValidateConfirmationVoData.lastName;
        authenticationValidateConfirmationApiData.password = authenticationValidateConfirmationVoData.password;
        authenticationValidateConfirmationApiData.organizationName = authenticationValidateConfirmationVoData.organizationName;
        ;
        authenticationValidateConfirmationApiData.organizationUri = authenticationValidateConfirmationVoData.organizationUri;
        ;
        authenticationValidateConfirmationApiData.contractTerm = authenticationValidateConfirmationVoData.contractTerm;
        ;
        authenticationValidateConfirmationApiData.usersCommitted = authenticationValidateConfirmationVoData.usersCommitted;
        ;
        authenticationValidateConfirmationApiData.language = authenticationValidateConfirmationVoData.language;
        ;
        authenticationValidateConfirmationApiData.provider = authenticationValidateConfirmationVoData.provider;
        ;
        authenticationValidateConfirmationApiData.accessToken = authenticationValidateConfirmationVoData.accessToken;
        ;
        authenticationValidateConfirmationApiData.accessTokenSecret = authenticationValidateConfirmationVoData.accessTokenSecret;
        ;
        authenticationValidateConfirmationApiData.fromUrl = authenticationValidateConfirmationVoData.fromUrl;
        ;
        authenticationValidateConfirmationApiData.keywords = authenticationValidateConfirmationVoData.keywords;
        ;
        authenticationValidateConfirmationApiData.path = authenticationValidateConfirmationVoData.path;
        ;
        authenticationValidateConfirmationApiData.userIp = authenticationValidateConfirmationVoData.userIp;
        ;
        authenticationValidateConfirmationApiData.registrationPage = authenticationValidateConfirmationVoData.registrationPage;
        ;
        authenticationValidateConfirmationApiData.domain = authenticationValidateConfirmationVoData.domain;
        authenticationValidateConfirmationApiData.hostedDomain = authenticationValidateConfirmationVoData.hostedDomain;
        authenticationValidateConfirmationApiData.taskDefaultView = authenticationValidateConfirmationVoData.taskDefaultView;
        authenticationValidateConfirmationApiData.alsaToken = authenticationValidateConfirmationVoData.alsaToken;
        ;
        authenticationValidateConfirmationApiData.stripeToken = authenticationValidateConfirmationVoData.stripeToken;
        authenticationValidateConfirmationApiData.planType = authenticationValidateConfirmationVoData.planType;
        ;
        return authenticationValidateConfirmationApiData;
    };
    AuthenticationConverter.convertToAuthenticationProcessConfirmationApiData = function (authenticationProcessConfirmationVoData) {
        var authenticationProcessConfirmationApiData = new AuthenticationProcessConfirmationApiData();
        authenticationProcessConfirmationApiData.firstName = authenticationProcessConfirmationVoData.firstName;
        authenticationProcessConfirmationApiData.lastName = authenticationProcessConfirmationVoData.lastName;
        authenticationProcessConfirmationApiData.password = authenticationProcessConfirmationVoData.password;
        authenticationProcessConfirmationApiData.organizationName = authenticationProcessConfirmationVoData.organizationName;
        ;
        authenticationProcessConfirmationApiData.organizationUri = authenticationProcessConfirmationVoData.organizationUri;
        ;
        authenticationProcessConfirmationApiData.contractTerm = authenticationProcessConfirmationVoData.contractTerm;
        ;
        authenticationProcessConfirmationApiData.usersCommitted = authenticationProcessConfirmationVoData.usersCommitted;
        ;
        authenticationProcessConfirmationApiData.language = authenticationProcessConfirmationVoData.language;
        ;
        authenticationProcessConfirmationApiData.provider = authenticationProcessConfirmationVoData.provider;
        ;
        authenticationProcessConfirmationApiData.accessToken = authenticationProcessConfirmationVoData.accessToken;
        ;
        authenticationProcessConfirmationApiData.accessTokenSecret = authenticationProcessConfirmationVoData.accessTokenSecret;
        ;
        authenticationProcessConfirmationApiData.fromUrl = authenticationProcessConfirmationVoData.fromUrl;
        ;
        authenticationProcessConfirmationApiData.keywords = authenticationProcessConfirmationVoData.keywords;
        ;
        authenticationProcessConfirmationApiData.path = authenticationProcessConfirmationVoData.path;
        ;
        authenticationProcessConfirmationApiData.userIp = authenticationProcessConfirmationVoData.userIp;
        ;
        authenticationProcessConfirmationApiData.registrationPage = authenticationProcessConfirmationVoData.registrationPage;
        ;
        authenticationProcessConfirmationApiData.domain = authenticationProcessConfirmationVoData.domain;
        authenticationProcessConfirmationApiData.hostedDomain = authenticationProcessConfirmationVoData.hostedDomain;
        authenticationProcessConfirmationApiData.taskDefaultView = authenticationProcessConfirmationVoData.taskDefaultView;
        authenticationProcessConfirmationApiData.alsaToken = authenticationProcessConfirmationVoData.alsaToken;
        ;
        authenticationProcessConfirmationApiData.stripeToken = authenticationProcessConfirmationVoData.stripeToken;
        authenticationProcessConfirmationApiData.planType = authenticationProcessConfirmationVoData.planType;
        ;
        return authenticationProcessConfirmationApiData;
    };
    return AuthenticationConverter;
}());
export { AuthenticationConverter };
//# sourceMappingURL=authentication-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/authentication-converter.js
// module id = 966
// module chunks = 14